import { Pipe, PipeTransform } from '@angular/core';
import { Markup } from '@app/features/pricing-and-availability';

@Pipe({
  standalone: true,
  name: 'listingMarkup',
})
export class ListingMarkupPipe implements PipeTransform {
  transform(listing_id: string, markups: Markup[]): unknown {
    if (!markups) {
      return null;
    }

    const markup = markups.find((x) => x.listing_id === listing_id);
    return markup.markup === null ? null : markup.markup * 100 || 0;
  }
}
